<template>

  <v-layout d-flex>
    <v-flex  xs7>
      <VueCodeHighlight style="width:100%; margin-top:-20px;">
        <pre class="language-javascript">
          <code>

npm install smartpress

Download the cloud configuration file



const Smartpress = require('smartpress')

const spConfig = require('./secret/smartpress.js')

let smartpress = new Smartpress(spConfig)









// EXAMPLE TRANSACTION

// SEND TOKEN
let transfer = {
  sender: '*user_1*',
  receiver: '*user_2*',
  assetType: 'token',
  symbol: 'AAA',
  amount: Number(1),
  memo: 'Your immutable message'
}
smartpress.sendAsset(transfer)









// CREATE ACCOUNT (User wallet)
let user = {
  user_id: '*user_id*',
}

smartpress.createAccount(user)






// GET BALANCE
let balance = {
  user_id: '*user_id*',
  symbol: 'AAA'
}

smartpress.getBalance(balance)

/* If you want the balance of your main contract,
 flag {contract_balance:true} and leave out user_id
 and symbol from the request */



          </code>
        </pre>
      </VueCodeHighlight>
    </v-flex>
    <v-flex d-flex xs5 style=" background-color:black">
             
        <pre style="color:white;font-size:16px;margin:36px 20px;" >
         

// First up

// And

// Then

// Require smartpress library

// Find this by pressing the config file button above

// initialise the library










// Response
{ 
  success: true, 
  data: { 
    contract: "sptoken22325", 
    transaction_id: "c3f5...f633", 
    action_type: "transfer", 
    time: 1573539270302, 
    data: "hi", 
    primary_actor: "emerald12242", 
    secondary_actor: "emerald12235", 
    no_units: 1, 
    symbol: "AAA", 
    block_explorer: "https://telos.eosx.io/tx/c3f5...f633" 
  } 
}




// Response
{ 
  success: true, 
  account_name: "emerald83624", 
  user_id: "user-abc-123" 
}






// Response
{ 
  user_id: "user-abc-123",
  symbol: "AAA",
  contract: "sptoken22325",
  contract_balance: false,
  account_name: "emerald12241",
  balance: "32.0000 AAA",
  no_units: "32.0000" 
}



       
        </pre>
    
    </v-flex>
  </v-layout>
</template>

<script>
  import store from "@/store"

  import { component as VueCodeHighlight } from 'vue-code-highlight';

  export default {
    data () {
      return {
 
        abc: '123',
        items: [
          { x: 100, text: 'Getting started' },
          { x: 300, text: 'Create' },
          { x: 500, text: 'Issue' },
          { x: 800, text: 'Transfer' },
          { divider: true },
        ]
      }
    },
    components: {
      VueCodeHighlight
    },
    props: {
      keys: String,
      account: String
    },
    watch:  {
 
    
    },
    methods: {
      goto(x) {
        this.$vuetify.goTo(x)
      }
    },
    destroyed: function () {
    }
  }
</script>

<style>
  .test {
    color:red;
  }
</style>
